/* ─────────────────────────────────────────────────────────────────
   fit-headings.js — a safety net for long words in big headings.
   Headings never break mid-word (see base.css), so a long word in a big heading
   ("Commissioning" at section-heading size on a narrow phone) can run past its
   column and be clipped. This shrinks just that heading until its longest word
   fits (by at most 25%; 40% for tile names), so it's barely noticeable. Headings that already fit are
   never touched. Re-checked on resize and when fonts finish loading. No JS → the
   packages' own sizes, as before.
   Covers the hero headline, page titles, section headings, feature titles, strong
   subheadings and grid tile names (which may shrink to 60%: their tiles are narrow).
   The one place a size is set outside the type packages: an inline font-size on
   the heading itself, and only when it would otherwise overflow.
   ───────────────────────────────────────────────────────────────── */
(function () {
  var SELECTOR = '.ae-display, .ae-page-title, .ae-heading, .ae-feature-title, .ae-subheading-strong, .ae-tile-title';
  // Tile names (Folio, Selected Projects, Collect, the Shop grid) sit in narrow tiles,
  // so they may shrink further than the big headings.
  function minScale(el) {
    return el.classList.contains('ae-tile-title') ? 0.6 : 0.75;
  }

  // The width the heading must fit: its own box, or its parent's content box if
  // that's narrower (a heading sized to its content can grow past its column).
  function available(el) {
    var parent = el.parentElement;
    var width = el.clientWidth;
    if (parent) {
      var cs = getComputedStyle(parent);
      var inner = parent.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (inner > 0 && inner < width) width = inner;
    }
    return width;
  }

  function fit(el) {
    el.style.fontSize = '';
    var width = available(el);
    if (!width || el.scrollWidth <= width + 1) return;
    var base = parseFloat(getComputedStyle(el).fontSize);
    var floor = base * minScale(el);
    var size = base;
    // Two passes: scale by the overflow ratio, then correct for rounding / kerning.
    for (var i = 0; i < 2 && el.scrollWidth > available(el) + 1; i++) {
      size = Math.max(floor, size * (available(el) / el.scrollWidth) * 0.98);
      el.style.fontSize = size + 'px';
      if (size === floor) break;
    }
  }

  function fitAll(root) {
    (root && root.querySelectorAll ? root : document).querySelectorAll(SELECTOR).forEach(fit);
  }

  // For content revealed after load (hidden headings measure 0 and are skipped),
  // e.g. the Shop grid's "Load more": call window.aeFitHeadings(container).
  window.aeFitHeadings = fitAll;

  var timer;
  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(function () { fitAll(); }, 150);
  }

  fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitAll(); });
  window.addEventListener('resize', onResize, { passive: true });
  // Theme editor: re-check a section after it's re-rendered.
  document.addEventListener('shopify:section:load', function () { fitAll(); });
})();
